import { Box, Chip } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { i18n } from '../../i18n/i18n';

interface ChipListProps {
    list: any;
}

const ChipList: React.FC<ChipListProps> = ({ list }) => {
    const [firstRowIndex, setFirstRowIndex] = useState(null);
    const [expended, setExpended] = useState(false);
    const [showChips, setShowChips] = useState(false);
    const chipsRef = useRef([]);
    useEffect(() => {
        let firstRowIndex = 0;
        if (chipsRef.current.length) {
            const topFirstRow = chipsRef.current[0].getBoundingClientRect().top;
            chipsRef.current.forEach((chip, index) => {
                const chipTop = chip.getBoundingClientRect().top;
                if (chipTop === topFirstRow) {
                    firstRowIndex++;
                }
            });
            setFirstRowIndex(firstRowIndex);
        }
        if (!isNaN(firstRowIndex)) {
            setShowChips(true);
        }
    }, [chipsRef.current]);

    const getList = useCallback(() => {
        const suffix = [];
        const baseList = list
            .filter((part, index) => !firstRowIndex || expended || index <= firstRowIndex - 1)
            .map((part, index) => (
                <Chip ref={(el) => (chipsRef.current[index] = el)} label={`${part.key}: ${part.value}`} />
            ));
        if (list.length - firstRowIndex > 0) {
            if (expended) {
                suffix.push(
                    <Chip
                        style={{ backgroundColor: 'transparent' }}
                        label={i18n.translate('Show Less')}
                        onClick={() => setExpended(false)}
                    />,
                );
            } else {
                suffix.push(
                    <Chip
                        style={{ backgroundColor: 'transparent' }}
                        label={`+${list.length - firstRowIndex}`}
                        onClick={() => setExpended(true)}
                    />,
                );
            }
        }

        return (
            <Box
                sx={{
                    display: 'flex',
                    visibility: showChips ? 'visible' : 'hidden',
                    height: showChips ? null : 0,
                    flexWrap: 'wrap',
                    gap: 1,
                }}
            >
                {[...baseList, ...suffix]}
            </Box>
        );
    }, [firstRowIndex, expended, showChips]);
    return getList();
};

export default ChipList;
